import {
  IHouseStepSpaceType,
  IWizardHouseState,
  TStepErrors,
  TStepPayload,
  TWizardStepComponentEditable,
  TWizardStepComponentEditableView,
  WIZARD_HOUSE_STEPS_PATHS
} from "../../../interfaces";
import { StepViewOnlyValue } from "../../../Student/styles";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  createCheckIsReadonlyStepField,
  getStepErrorsFromResponse
} from "../../../utils";

import { HouseAPI } from "../../../../../API/houseApi";
import { TYPE_ROOM } from "../../../../../utils/constants";
import styled from "styled-components/macro";
import { THouseType } from "../../../../../interfaces/interfaces";
import RoomImage from "assets/images/wizard/RoomType_Room.png";
import StudioImage from "assets/images/wizard/RoomType_Studio.png";
import HouseImage from "assets/images/wizard/RoomType_House.png";
import { CardButton } from "../../../../Button/CardButton";

const statePath = WIZARD_HOUSE_STEPS_PATHS.SpaceType;
export const WizardStepSpaceType: TWizardStepComponentEditable<IWizardHouseState> =
  forwardRef(({ state, readonly, viewonly }, ref) => {
    const [values, setValues] = useState<TStepPayload<IHouseStepSpaceType>>(
      state[statePath] ?? {}
    );
    const [errors, setErrors] = useState<TStepErrors<typeof values>>(null);

    useImperativeHandle(ref, () => ({
      save: () => {
        setErrors(null);
        return HouseAPI.wizardSaveSpaceType(
          state.house_id!,
          state.wizard_type!,
          values
        )
          .then((result) => {
            return {
              ...state,
              [statePath]: result
            };
          })
          .catch((e) => {
            setErrors(getStepErrorsFromResponse(e));
            return Promise.reject(e);
          });
      }
    }));

    return (
      <WizardStepSpaceTypeView
        values={values}
        setValues={setValues}
        errors={errors}
        readonly={readonly}
        viewonly={viewonly}
      />
    );
  });

export const ROOM_TYPE_ICONS: {
  [key in THouseType]: React.ReactNode;
} = {
  entire_house: <img src={HouseImage} alt="" />,
  room: <img src={RoomImage} alt="" />,
  studio: <img src={StudioImage} alt="" />
};

const Root = styled.div``;
const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 40px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const WizardStepSpaceTypeView: TWizardStepComponentEditableView<
  IHouseStepSpaceType
> = ({ errors, values, setValues, viewonly, readonly, enabledFields }) => {
  const { t } = useTranslation("house");

  const spaceTypeOptions = TYPE_ROOM.map((v) => ({
    value: v,
    label: t(`wizard.steps.SpaceType.form.kind.options.${v}`),
    description: t(`wizard.steps.SpaceType.form.kind.options_description.${v}`),
    icon: ROOM_TYPE_ICONS[v]
  }));

  const isReadonly = createCheckIsReadonlyStepField(readonly, enabledFields);

  return (
    <Root>
      {viewonly ? (
        <StepViewOnlyValue>
          {t(`wizard.steps.SpaceType.form.kind.title`)}:{" "}
          {spaceTypeOptions.find((o) => values?.kind === o.value)?.label}
        </StepViewOnlyValue>
      ) : (
        <>
          <CardsContainer>
            {spaceTypeOptions.map((o) => (
              <CardButton
                readonly={isReadonly("kind")}
                key={o.value}
                label={o.label}
                description={o.description}
                selected={values.kind === o.value}
                icon={o.icon}
                onClick={() => {
                  setValues({ ...values, kind: o.value });
                }}
              />
            ))}
          </CardsContainer>
        </>
      )}
      {errors?.kind ? (
        <div style={{ color: "red" }}>
          {" "}
          {t(`wizard.steps.SpaceType.error`)}{" "}
        </div>
      ) : null}
    </Root>
  );
};
//
